import { render } from "./index.vue?vue&type=template&id=2cf3711d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2cf3711d&lang=less&scoped=true"

import exportComponent from "D:\\codeDevelopment\\文稿通\\wgt_user_web_2.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf3711d"]])

export default __exports__